<!--
/*******************************************************************************
*@ 컴포넌트명   : Calendar.vue
*@ 컴포넌트설명 : 달력 공통컴포넌트
*@ 사용라이브러리: https://vcalendar.io
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <div class="form-datepicker">
    <!-- 처음부터 펼쳐져 있는 달력([조회] > [거래내역조회] > [달력조회] 메뉴에서 사용) -->
    <template v-if="autoOpen">
      <v-calendar
        ref="calendar"
        v-model="date"
        locale="en"
        :masks="{title: 'MM/YYYY'}"
        :min-date="$getStringToDate(minDate)"
        :max-date="$getStringToDate(maxDate)"
        @dayclick="dayClick"
        @update:from-page="(e) => {pageInfo = e}"
        :show-week="false"
        :attributes="attrs"
      ></v-calendar>
    </template>
    <!-- input-icon 형태의 달력 -->
    <template v-else>
      <div
        class="input-text-field half right-icon"
        :class="{ disabled: disabled }"
        @click="() => calendarOpened = !disabled"
      >
        <input
          type="text"
          id="textfield1"
          class="form-control"
          :value="$getGlobalDateFmt($getDateToString(value))"
          readonly
        />
        <i class="icon icon-calendar"></i>
      </div>
      <popup :opened.sync="calendarOpened" :use-footer="true" :title="titleI18n">
        <template #content>
          <article class="contents calendar">
            <v-date-picker
              ref="calendar"
              v-model="date"
              locale="en"
              :masks="{title: 'MM/YYYY'}"
              :min-date="$getStringToDate(minDate)"
              :max-date="$getStringToDate(maxDate)"
            ></v-date-picker>
    
          </article>
        </template>
        <template #footer>
          <button class="btn md gray" @click="cancelCall">{{/*취소*/$t("MCOM-0000002")}}</button>
          <button class="btn md normal" @click="confirmCall">{{/*확인*/$t("MCOM-0000003")}}</button>
        </template>
      </popup>
    </template>
  </div>
</template>
<script>
import BaseContent from "@/components/BaseContent";
import { calendarRangeDateSet } from "@/mixins/basicComponent";
export default {
  name: "Calendar",
  extends: BaseContent,
  mixins: [calendarRangeDateSet],
  props: {
    value: {
      required: true,
    },
    dateRange: {
      type: String,
      default: "SUBTRACT_TEN_YEAR",
    },
    autoOpen: {
      type: Boolean,
      default: false,
    },
    attrs: Array,
    disabled: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      date: "",
      weeks: [],
      selectedWeek: -1,
      pageDay: {},
   
    };
  },
  created() {
    if (this.value != "") this.date = this.$getStringToDate(this.value);
  },
  computed: {
    /**
     * autoOpen == true 일 때만 사용.
     * 캘린더 현재 페이지 정보
     */
    pageInfo: {
      get() {
        return this.pageDay;
      },
      set(value) {
        this.pageDay = value;
        this.$log.info({ pageInfo_set_value: value });
        this.$emit("changeMmYyyy", this.$getMonth(this.pageDay.year, this.pageDay.month));
      },
    },
  },
  methods: {
    /**
     * 변경된 attributes 적용
     */
    refresh() {
      this.$refs.calendar.refreshAttrs();
    },
    /**
     * 캘린더 팝업 닫기
     */
    close() {
      this.calendarOpened = false;
    },
    /**
     * 캘린더 팝업 취소 - 선택한 날짜 미적용
     */
    cancelCall() {
      this.date = "";
      this.close();
    },
    /**
     * 캘린더 팝업 확인 - 선택한 날짜 적용
     */
    confirmCall() {
      this.$emit("update:value", this.$getDateToString(this.date));
      this.close();
    },
    /**
     * autoOpen==true 일때,
     * 날짜 클릭시 선택한 달력의 row만 show, $emit("dayClick")
     * @param {Event} e calendar info
     * @return {Date} 선택한 날짜
     */
    dayClick(e) {
      if (_.has(e.isDisabled, "isDate")) return false;
      this.selectedWeek = e.week;
      this.weeks = [];
      let days = [];
      let i = 0;
      for (const data of document.querySelector(".vc-weeks").children) {
        if (data.classList.contains("vc-day")) {
          i++;
          if (i > 1 && i % 7 == 1) {
            this.weeks[this.weeks.length] = days;
            days = [];
          }
          days.push(data);
        }
      }
      this.weeks[this.weeks.length] = days;

      i = 0;
      for (const week of this.weeks) {
        i++;
        for (const day of week) {
          if (this.selectedWeek != i) {
            day.classList.add("display-none");
          }
        }
      }
      this.$emit("dayClick", this.$getDateToString(e.date));
    },
    /**
     * date set
     * @param {String} value YYYYMMDD 형식의 날짜
     */
    setDate(value) {
      this.date = this.$getStringToDate(value);
      this.$emit("update:value", value);
    },
    /**
     * 오늘 달력으로 이동
     */
    moveToday() {
      this.$refs.calendar.move(this.moment()._d);
      this.$emit("changeMmYyyy", this.$getMonth(this.pageDay.year, this.pageDay.month));
    },
    /**
     * 달력 row show
     */
    allRowShow() {
      let i = 0;
      for (const week of this.weeks) {
        i++;
        for (const day of week) {
          if (this.selectedWeek != i) {
            day.classList.remove("display-none");
          }
        }
      }
    },
  },
  directives: {
    "click-outside": {
      bind(el, binding, vnode) {
        el.clickOutSideEvent = function(event) {
          if (!(el == event.target || el.contains(event.target))) {
            vnode.context[binding.expression](event);
          }
        };
        document.body.addEventListener("click", el.clickOutSideEvent);
      },
      unbind(el) {
        document.body.removeEventListener("click", el.clickOutSideEvent);
      },
    },
  },
};
</script>